"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Journey() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const trustPoints = [{
    label: "Expert Builder Network"
  }, {
    label: "Verified Market Data"
  }, {
    label: "Central Ohio Focus"
  }];
  return <section data-section-id="888" id="start-your-journey" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-40 px-4 sm:px-6 lg:px-8">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[600px] w-[600px] md:h-[900px] md:w-[900px] rounded-lg opacity-60 blur-[200px]" style={{
      background: "var(--primary)"
    }} />
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-[60%] -translate-y-[40%] h-[400px] w-[400px] md:h-[600px] md:w-[600px] rounded-lg opacity-25 blur-[180px]" style={{
      background: "var(--chart-2)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{
      backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-[880px] flex flex-col items-center text-center">
        {}
        <div className={`flex items-center gap-2.5 mb-10 transition-all duration-700 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-lg opacity-75" style={{
            background: "var(--primary)"
          }} />
            <span className="relative inline-flex h-2 w-2 rounded-lg" style={{
            background: "var(--primary)"
          }} />
          </span>
          <span className="font-default text-xs uppercase tracking-widest text-muted-foreground">
            New Home Resources
          </span>
        </div>

        {}
        <div ref={headlineRef} className={`relative w-full transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span aria-hidden="true" className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 font-default text-[120px] lg:text-[180px] leading-none text-muted-foreground/30 select-none">
            [
          </span>
          <span aria-hidden="true" className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 font-default text-[120px] lg:text-[180px] leading-none text-muted-foreground/30 select-none">
            ]
          </span>

          <h2 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[96px] font-medium tracking-tight" style={{
          lineHeight: "0.95"
        }}>
            Ready to build your{" "}
            <em className="italic font-normal" style={{
            color: "var(--primary)"
          }}>
              dream home
            </em>
            ?
          </h2>
        </div>

        {}
        <p className={`mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl transition-all duration-1000 delay-150 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          Compare the top-rated home builders in Central Ohio and start your journey with confidence.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-1000 delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild size="lg" className="rounded-lg h-auto px-8 py-[18px] text-base font-semibold group shadow-lg hover:shadow-xl transition-all">
            <Link to="#">
              Compare Builders
              <ArrowRight className="ml-1 size-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild variant="ghost" size="lg" className="rounded-lg h-auto px-8 py-[18px] text-base font-medium border border-border hover:bg-accent hover:text-accent-foreground">
            <Link to="#">Contact Our Team</Link>
          </Button>
        </div>

        {}
        <div className={`mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-default text-xs uppercase tracking-wider text-muted-foreground transition-all duration-1000 delay-500 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {trustPoints.map((point, i) => <div data-index={i} key={i} className="flex items-center gap-3">
              {i > 0 && <span className="inline-block h-1 w-1 rounded-lg" style={{
            background: "var(--primary)"
          }} aria-hidden="true" />}
              <span>{point.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}